import React from 'react';
import ContactSupportOutlinedIcon from '@mui/icons-material/ContactSupportOutlined';
import {
  formatMoney,
  isNilOrZero,
} from '@populateui/utils';
import AmountTag from 'pages/Dashboard/pages/Billing/AmountTag';
import {
  billingEventChannel,
} from 'pages/Dashboard/services/eventChannels';

type Props = {
  encounterId: number;
  amount?: number;
  useColors?: boolean;
};

export default function InsuranceBalanceExplanation({
  encounterId,
  amount,
  useColors = false,
}: Props) {
  return !isNilOrZero(encounterId) ? (
    <AmountTag
      tooltip="View explanation of insurance balance"
      value={amount ?? 0}
      useColors={useColors}
      onClick={(event) => {
        event.stopPropagation();
        billingEventChannel.emit('onInsuranceBalanceExplanationDialogOpen', {
          encounterId,
        });
      }}
      conditionalValue={amount}
    >
      <div className="flex items-center gap-1 !text-[12px]">
        {formatMoney(amount ?? 0)}
        <ContactSupportOutlinedIcon className="!w-3.5 !h-3.5 -mt-0.5 shrink-0" />
      </div>
    </AmountTag>
  ) : null;
}
